import type { ReactElement, ReactNode, SyntheticEvent } from "react"
import type {
  UdsButtonConcept,
  UdsButtonVariant,
} from "@gatsby-plugin-generic-page/fragments/udsButton"
import { Button } from "@ionos-web-design-system/react"

type ProductBoxButtonProps = {
  concept: UdsButtonConcept
  variant: UdsButtonVariant
  children: ReactNode
  onClick?: (event: SyntheticEvent) => void
  disabled?: boolean
  dataTestId?: string
}

export default function ProductBoxButton({
  concept,
  variant,
  children,
  onClick,
  disabled,
  dataTestId,
}: ProductBoxButtonProps): ReactElement<ProductBoxButtonProps> {
  return (
    <Button
      variant={variant}
      concept={concept}
      size="medium"
      className="w-full"
      onClick={onClick}
      disabled={disabled}
      data-test-id={dataTestId}
    >
      {children}
    </Button>
  )
}
